// src/utils/marathiTranslator.js

const PROPER_NOUN_MAP = {
    // Private Sector Banks
    "AXIS BANK LTD.": "एक्सिस बँक",
    "AXIS BANK": "एक्सिस बँक",
    "AXIS": "एक्सिस",
    "BANDHAN BANK LTD.": "बंधन बँक",
    "CSB BANK LIMITED": "सीएसबी बँक",
    "CITY UNION BANK LTD.": "सिटी युनियन बँक",
    "DCB BANK LTD.": "डीसीबी बँक",
    "DHANLAXMI BANK LTD.": "धनलक्ष्मी बँक",
    "FEDERAL BANK LTD.": "फेडरल बँक",
    "HDFC BANK LTD.": "एचडीएफसी बँक",
    "HDFC BANK": "एचडीएफसी बँक",
    "HDFC": "एचडीएफसी",
    "ICICI BANK LTD.": "आयसीआयसीआय बँक",
    "ICICI BANK": "आयसीआयसीआय बँक",
    "ICICI": "आयसीआयसीआय",
    "INDUSIND BANK LTD.": "इंडसइंड बँक",
    "IDFC FIRST BANK LIMITED": "आयडीएफसी फर्स्ट बँक",
    "JAMMU & KASHMIR BANK LTD.": "जम्मू आणि काश्मीर बँक",
    "KARNATAKA BANK LTD.": "कर्नाटक बँक",
    "KARUR VYSYA BANK LTD.": "करूर वैश्य बँक",
    "KOTAK MAHINDRA BANK LTD.": "कोटक महिंद्रा बँक",
    "KOTAK": "कोटक",
    "NAINITAL BANK LTD.": "नैनीताल बँक",
    "RBL BANK LTD.": "आरबीएल बँक",
    "SOUTH INDIAN BANK LTD.": "साउथ इंडियन बँक",
    "TAMILNAD MERCANTILE BANK LTD.": "तामिळनाड मर्कंटाइल बँक",
    "YES BANK LTD.": "येस बँक",
    "IDBI BANK LIMITED": "आयडीबीआय बँक",

    // Small Finance Banks
    "AU SMALL FINANCE BANK LTD.": "एयू स्मॉल फायनान्स बँक",
    "CAPITAL SMALL FINANCE BANK LTD.": "कॅपिटल स्मॉल फायनान्स बँक",
    "EQUITAS SMALL FINANCE BANK LTD.": "इक्विटास स्मॉल फायनान्स बँक",
    "ESAF SMALL FINANCE BANK LTD.": "ईएसएएफ स्मॉल फायनान्स बँक",
    "SURYODAY SMALL FINANCE BANK LTD.": "सूर्योदय स्मॉल फायनान्स बँक",
    "UJJIVAN SMALL FINANCE BANK LTD.": "उज्जीवन स्मॉल फायनान्स बँक",
    "UTKARSH SMALL FINANCE BANK LTD.": "उत्कर्ष स्मॉल फायनान्स बँक",
    "JANA SMALL FINANCE BANK LTD.": "जना स्मॉल फायनान्स बँक",

    // Payments Banks
    "AIRTEL PAYMENTS BANK LTD.": "एअरटेल पेमेंट्स बँक",
    "PAYTM PAYMENTS BANK LTD.": "पेटीएम पेमेंट्स बँक",
    "JIO PAYMENTS BANK LTD.": "जियो पेमेंट्स बँक",

    // Public Sector Banks
    "BANK OF BARODA": "बँक ऑफ बडोदा",
    "BANK OF INDIA": "बँक ऑफ इंडिया",
    "BANK OF MAHARASHTRA": "बँक ऑफ महाराष्ट्र",
    "CANARA BANK": "केनरा बँक",
    "STATE BANK OF INDIA": "स्टेट बँक ऑफ इंडिया",
    "SBI": "एसबीआय",
    "PUNJAB NATIONAL BANK": "पंजाब नॅशनल बँक",

    // Suffixes
    "LTD.": "लि.",
    "LIMITED": "लिमिटेड",
    "PVT.": "प्रा.",
    "PRIVATE": "प्रायव्हेट",
    "BANK LTD.": "बँक",
    "BANK LIMITED": "बँक",
    "PLC.": "पीएलसी",

    "AXIS BANK LTD": "एक्सिस बँक",
    "AXIS BANK": "एक्सिस बँक",
    "AXIS": "एक्सिस",
    "BANDHAN BANK LTD": "बंधन बँक",
    "CSB BANK LIMITED": "सीएसबी बँक",
    "CITY UNION BANK LTD": "सिटी युनियन बँक",
    "DCB BANK LTD": "डीसीबी बँक",
    "DHANLAXMI BANK LTD": "धनलक्ष्मी बँक",
    "FEDERAL BANK LTD": "फेडरल बँक",
    "HDFC BANK LTD": "एचडीएफसी बँक",
    "HDFC BANK": "एचडीएफसी बँक",
    "HDFC": "एचडीएफसी",
    "ICICI BANK LTD": "आयसीआयसीआय बँक",
    "ICICI BANK": "आयसीआयसीआय बँक",
    "ICICI": "आयसीआयसीआय",
    "INDUSIND BANK LTD": "इंडसइंड बँक",
    "IDFC FIRST BANK LIMITED": "आयडीएफसी फर्स्ट बँक",
    "JAMMU & KASHMIR BANK LTD": "जम्मू आणि काश्मीर बँक",
    "KARNATAKA BANK LTD": "कर्नाटक बँक",
    "KARUR VYSYA BANK LTD": "करूर वैश्य बँक",
    "KOTAK MAHINDRA BANK LTD": "कोटक महिंद्रा बँक",
    "KOTAK": "कोटक",
    "NAINITAL BANK LTD": "नैनीताल बँक",
    "RBL BANK LTD": "आरबीएल बँक",
    "SOUTH INDIAN BANK LTD": "साउथ इंडियन बँक",
    "TAMILNAD MERCANTILE BANK LTD": "तामिळनाड मर्कंटाइल बँक",
    "YES BANK LTD": "येस बँक",
    "IDBI BANK LIMITED": "आयडीबीआय बँक",

    // Small Finance Banks
    "Tamilnad Mercantile Bank Limited": "तामिळनाड मर्कंटाइल बँक",
    "Punjab National Bank, Mumbai": "पंजाब नॅशनल बँक, मुंबई",
    "AU SMALL FINANCE BANK LTD": "एयू स्मॉल फायनान्स बँक",
    "CAPITAL SMALL FINANCE BANK LTD": "कॅपिटल स्मॉल फायनान्स बँक",
    "EQUITAS SMALL FINANCE BANK LTD": "इक्विटास स्मॉल फायनान्स बँक",
    "ESAF SMALL FINANCE BANK LTD": "ईएसएएफ स्मॉल फायनान्स बँक",
    "SURYODAY SMALL FINANCE BANK LTD": "सूर्योदय स्मॉल फायनान्स बँक",
    "UJJIVAN SMALL FINANCE BANK LTD": "उज्जीवन स्मॉल फायनान्स बँक",
    "UTKARSH SMALL FINANCE BANK LTD": "उत्कर्ष स्मॉल फायनान्स बँक",
    "NORTH EAST SMALL FINANCE BANK LTD": "नॉर्थ ईस्ट स्मॉल फायनान्स बँक",
    "JANA SMALL FINANCE BANK LTD": "जना स्मॉल फायनान्स बँक",
    "SHIVALIK SMALL FINANCE BANK LTD": "शिवालिक स्मॉल फायनान्स बँक",
    "UNITY SMALL FINANCE BANK LTD": "युनिटी स्मॉल फायनान्स बँक",

    // Payments Banks
    "AIRTEL PAYMENTS BANK LTD": "एअरटेल पेमेंट्स बँक",
    "INDIA POST PAYMENTS BANK LTD": "इंडिया पोस्ट पेमेंट्स बँक",
    "FINO PAYMENTS BANK LTD": "फिनो पेमेंट्स बँक",
    "PAYTM PAYMENTS BANK LTD": "पेटीएम पेमेंट्स बँक",
    "JIO PAYMENTS BANK LTD": "जियो पेमेंट्स बँक",
    "NSDL PAYMENTS BANK LIMITED": "एनएसडीएल पेमेंट्स बँक",

    // Public Sector Banks
    "BANK OF BARODA": "बँक ऑफ बडोदा",
    "BANK OF INDIA": "बँक ऑफ इंडिया",
    "BANK OF MAHARASHTRA": "बँक ऑफ महाराष्ट्र",
    "CANARA BANK": "केनरा बँक",
    "CENTRAL BANK OF INDIA": "सेंट्रल बँक ऑफ इंडिया",
    "INDIAN BANK": "इंडियन बँक",
    "INDIAN OVERSEAS BANK": "इंडियन ओव्हरसीज बँक",
    "PUNJAB & SIND BANK": "पंजाब अँड सिंध बँक",
    "PUNJAB NATIONAL BANK": "पंजाब नॅशनल बँक",
    "STATE BANK OF INDIA": "स्टेट बँक ऑफ इंडिया",
    "SBI": "एसबीआय",
    "MUMBAI": "मुंबई",
    "mumbai": "मुंबई",
    "Dharavi": "धरावी",
    "dharavi": "धरावी",
    "UCO BANK": "युको बँक",
    "UNION BANK OF INDIA": "युनियन बँक ऑफ इंडिया",

    // Financial Institutions
    "NABARD": "नाबार्ड",
    "EXIM BANK": "एक्झिम बँक",
    "axis bank ltd": "एक्सिस बँक",
    "axis bank": "एक्सिस बँक",
    "axis": "एक्सिस",
    "bandhan bank ltd": "बंधन बँक",
    "csb bank limited": "सीएसबी बँक",
    "city union bank ltd": "सिटी युनियन बँक",
    "dcb bank ltd": "डीसीबी बँक",
    "dhanlaxmi bank ltd": "धनलक्ष्मी बँक",
    "federal bank ltd": "फेडरल बँक",
    "hdfc bank ltd": "एचडीएफसी बँक",
    "hdfc bank": "एचडीएफसी बँक",
    "hdfc": "एचडीएफसी",
    "icici bank ltd": "आयसीआयसीआय बँक",
    "icici bank": "आयसीआयसीआय बँक",
    "icici": "आयसीआयसीआय",
    "indusind bank ltd": "इंडसइंड बँक",
    "idfc first bank limited": "आयडीएफसी फर्स्ट बँक",
    "jammu & kashmir bank ltd": "जम्मू आणि काश्मीर बँक",
    "karnataka bank ltd": "कर्नाटक बँक",
    "karur vysya bank ltd": "करूर वैश्य बँक",
    "kotak mahindra bank ltd": "कोटक महिंद्रा बँक",
    "kotak": "कोटक",
    "nainital bank ltd": "नैनीताल बँक",
    "rbl bank ltd": "आरबीएल बँक",
    "south indian bank ltd": "साउथ इंडियन बँक",
    "tamilnad mercantile bank ltd": "तामिळनाड मर्कंटाइल बँक",
    "yes bank ltd": "येस बँक",
    "idbi bank limited": "आयडीबीआय बँक",

    // Small Finance Banks
    "au small finance bank ltd": "एयू स्मॉल फायनान्स बँक",
    "capital small finance bank ltd": "कॅपिटल स्मॉल फायनान्स बँक",
    "equitas small finance bank ltd": "इक्विटास स्मॉल फायनान्स बँक",
    "esaf small finance bank ltd": "ईएसएएफ स्मॉल फायनान्स बँक",
    "suryoday small finance bank ltd": "सूर्योदय स्मॉल फायनान्स बँक",
    "ujjivan small finance bank ltd": "उज्जीवन स्मॉल फायनान्स बँक",
    "utkarsh small finance bank ltd": "उत्कर्ष स्मॉल फायनान्स बँक",
    "north east small finance bank ltd": "नॉर्थ ईस्ट स्मॉल फायनान्स बँक",
    "jana small finance bank ltd": "जना स्मॉल फायनान्स बँक",
    "shivalik small finance bank ltd": "शिवालिक स्मॉल फायनान्स बँक",
    "unity small finance bank ltd": "युनिटी स्मॉल फायनान्स बँक",

    // Payments Banks
    "airtel payments bank ltd": "एअरटेल पेमेंट्स बँक",
    "india post payments bank ltd": "इंडिया पोस्ट पेमेंट्स बँक",
    "fino payments bank ltd": "फिनो पेमेंट्स बँक",
    "paytm payments bank ltd": "पेटीएम पेमेंट्स बँक",
    "jio payments bank ltd": "जियो पेमेंट्स बँक",
    "nsdl payments bank limited": "एनएसडीएल पेमेंट्स बँक",

    // Public Sector Banks
    "bank of baroda": "बँक ऑफ बडोदा",
    "bank of india": "बँक ऑफ इंडिया",
    "bank of maharashtra": "बँक ऑफ महाराष्ट्र",
    "canara bank": "केनरा बँक",
    "central bank of india": "सेंट्रल बँक ऑफ इंडिया",
    "indian bank": "इंडियन बँक",
    "indian overseas bank": "इंडियन ओव्हरसीज बँक",
    "punjab & sind bank": "पंजाब अँड सिंध बँक",
    "punjab national bank": "पंजाब नॅशनल बँक",
    "state bank of india": "स्टेट बँक ऑफ इंडिया",
    "sbi": "एसबीआय",
    "uco bank": "युको बँक",
    "union bank of india": "युनियन बँक ऑफ इंडिया",

    // Suffixes
    "ltd": "लि",
    "limited": "लिमिटेड",
    "pvt": "प्रा",
    "private": "प्रायव्हेट",
    "bank ltd": "बँक",
    "bank limited": "बँक",
    "plc": "पीएलसी",


    // Public Sector Banks

"Bank of Baroda": "बँक ऑफ बडोदा",
"Bank of India": "बँक ऑफ इंडिया",
"Bank of Maharashtra": "बँक ऑफ महाराष्ट्र",
"Canara Bank": "कॅनरा बँक",
"Central Bank of India": "सेंट्रल बँक ऑफ इंडिया",
"Indian Bank": "इंडियन बँक",
"Indian Overseas Bank": "इंडियन ओव्हरसीज बँक",
"Punjab & Sind Bank": "पंजाब अँड सिंध बँक",
"Punjab National Bank": "पंजाब नॅशनल बँक",
"State Bank of India": "स्टेट बँक ऑफ इंडिया",
"UCO Bank": "युको बँक",
"Union Bank of India": "युनियन बँक ऑफ इंडिया",

// Common Aliases

"SBI": "स्टेट बँक ऑफ इंडिया",
"PNB": "पंजाब नॅशनल बँक",
"BOB": "बँक ऑफ बडोदा",
"BOI": "बँक ऑफ इंडिया",
"BOM": "बँक ऑफ महाराष्ट्र",
"UCO": "युको बँक",
"UNION BANK": "युनियन बँक ऑफ इंडिया",
"CANARA": "कॅनरा बँक",
"CENTRAL BANK": "सेंट्रल बँक ऑफ इंडिया",
// Regional Rural Banks (RRB)

"Andhra Pradesh Grameena Bank": "आंध्र प्रदेश ग्रामीण बँक",
"Assam Gramin Bank": "आसाम ग्रामीण बँक",
"Arunachal Pradesh Rural Bank": "अरुणाचल प्रदेश ग्रामीण बँक",
"Bihar Gramin Bank": "बिहार ग्रामीण बँक",
"Chhattisgarh Gramin Bank": "छत्तीसगड ग्रामीण बँक",
"Gujarat Gramin Bank": "गुजरात ग्रामीण बँक",
"Haryana Gramin Bank": "हरियाणा ग्रामीण बँक",
"Himachal Pradesh Gramin Bank": "हिमाचल प्रदेश ग्रामीण बँक",
"Jharkhand Gramin Bank": "झारखंड ग्रामीण बँक",
"Jammu and Kashmir Grameen Bank": "जम्मू आणि काश्मीर ग्रामीण बँक",
"Karnataka Grameena Bank": "कर्नाटक ग्रामीण बँक",
"Kerala Grameena Bank": "केरळ ग्रामीण बँक",
"Maharashtra Gramin Bank": "महाराष्ट्र ग्रामीण बँक",
"Madhya Pradesh Gramin Bank": "मध्य प्रदेश ग्रामीण बँक",
"Manipur Rural Bank": "मणिपूर ग्रामीण बँक",
"Meghalaya Rural Bank": "मेघालय ग्रामीण बँक",
"Mizoram Rural Bank": "मिझोरम ग्रामीण बँक",
"Nagaland Rural Bank": "नागालँड ग्रामीण बँक",
"Odisha Grameen Bank": "ओडिशा ग्रामीण बँक",
"Punjab Gramin Bank": "पंजाब ग्रामीण बँक",
"Puducherry Grama Bank": "पुदुच्चेरी ग्राम बँक",
"Rajasthan Gramin Bank": "राजस्थान ग्रामीण बँक",
"Tamil Nadu Grama Bank": "तामिळनाडू ग्राम बँक",
"Telangana Grameena Bank": "तेलंगणा ग्रामीण बँक",
"Tripura Gramin Bank": "त्रिपुरा ग्रामीण बँक",
"Uttar Pradesh Gramin Bank": "उत्तर प्रदेश ग्रामीण बँक",
"Uttarakhand Gramin Bank": "उत्तराखंड ग्रामीण बँक",
"West Bengal Gramin Bank": "पश्चिम बंगाल ग्रामीण बँक",
};
export function translateToMarathi(text) {
    if (!text || typeof text !== "string") return text;

    const normalize = (str) =>
        str
            .toUpperCase()
            .replace(/\./g, "")
            .replace(/,/g, "")
            .replace(/\s+/g, " ")
            .trim();

    const normalizedText = normalize(text);

    // 1. Try exact match first
    for (const [key, value] of Object.entries(PROPER_NOUN_MAP)) {
        if (normalize(key) === normalizedText) {
            // Even on exact match, still apply suffix translation
            return value;
        }
    }

    // 2. No exact match — translate word by word
    const wordMap = {
        "BANK": "बँक",
        "LTD": "लि.",
        "LTD.": "लि.",
        "LIMITED": "लिमिटेड",
        "PVT": "प्रा.",
        "PVT.": "प्रा.",
        "PRIVATE": "प्रायव्हेट",
        "AND": "आणि",
        "&": "आणि",
        "OF": "ऑफ",
        "INDIA": "इंडिया",
        "NATIONAL": "नॅशनल",
        "SMALL": "स्मॉल",
        "FINANCE": "फायनान्स",
        "PAYMENTS": "पेमेंट्स",
        "CO": "को",
        "COOPERATIVE": "सहकारी",
        "URBAN": "अर्बन",
        "RURAL": "रूरल",
        "CENTRAL": "सेंट्रल",
        "STATE": "स्टेट",
        "Delhi": "दिल्ली",
        "Mumbai": "मुंबई",
        "mumbai": "मुंबई",
        "Dharavi": "धरावी",
        "dharavi": "धरावी",
    };

    return text
        .split(" ")
        .map(word => {
            const key = word.toUpperCase().replace(/\.$/g, "");
            const keyWithDot = word.toUpperCase();
            return wordMap[keyWithDot] || wordMap[key] || word;
        })
        .join(" ")
        .trim();
}